/* eslint-disable no-restricted-syntax */
import { create } from 'ipfs-http-client';

import { getIPFSGateWayURL } from './getIPFSAssets';

export const getIPFSDirectoryContent = async (ipfsPath: any) => {
  const gatewayURL = await getIPFSGateWayURL();
  const url = `${gatewayURL}/api/v0`;
  const ipfs = create({ url });
  const links = [];
  const allData = ipfs.ls(ipfsPath);
  for await (const link of allData) {
    links.push(link);
  }
  return { links, gatewayURL };
};
